import styled from 'styled-components';

export const StapleTableWrapperStyled = styled.div`
  margin-top: 2rem;
  margin-bottom: 5rem;
`;
